import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  BroadcastMessage,
  BroadcastMessageListItem,
  BroadcastMessageSearchDto,
  CreateBroadcastMessageDto,
  PreviewRecipientsDto,
  PreviewRecipientsResponse,
  UpdateBroadcastMessageDto
} from '../models/broadcast-message.model';
import { PagedResultDto } from '../models/paged-result.model';

@Injectable({ providedIn: 'root' })
export class BroadcastMessageService {
  private readonly baseUrl = '/api/messages';

  constructor(private http: HttpClient) {}

  /**
   * Creates a new broadcast message.
   * Can be saved as draft, scheduled, or sent immediately.
   */
  createMessage(dto: CreateBroadcastMessageDto): Observable<BroadcastMessage> {
    return this.http.post<BroadcastMessage>(this.baseUrl, dto);
  }

  /**
   * Get message by ID
   * @param id - Message ID
   * @param includeRecipients - Include per-recipient delivery status (default: false)
   */
  getMessageById(
    id: string,
    includeRecipients = false
  ): Observable<BroadcastMessage> {
    const params = new HttpParams().set(
      'includeRecipients',
      String(includeRecipients)
    );

    return this.http.get<BroadcastMessage>(`${this.baseUrl}/${id}`, { params });
  }

  /**
   * List messages with optional filters and pagination
   */
  listMessages(
    searchDto?: BroadcastMessageSearchDto
  ): Observable<PagedResultDto<BroadcastMessageListItem>> {
    const params = HttpHelper.toHttpParams(searchDto ?? {});
    return this.http.get<PagedResultDto<BroadcastMessageListItem>>(
      this.baseUrl,
      { params }
    );
  }

  /**
   * Update a draft or scheduled message.
   * Cannot update messages that are processing or already sent.
   */
  updateMessage(
    id: string,
    dto: UpdateBroadcastMessageDto
  ): Observable<BroadcastMessage> {
    return this.http.patch<BroadcastMessage>(`${this.baseUrl}/${id}`, dto );
  }

  /**
   * Delete a draft or cancel a scheduled message.
   * Cannot delete sent or processing messages.
   */
  deleteMessage(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/${id}`);
  }

  /**
   * 
   * @param dto 
   * @returns 
   */
  previewRecipients(
    dto: PreviewRecipientsDto
  ): Observable<PreviewRecipientsResponse> {
    return this.http.post<PreviewRecipientsResponse>(
      `${this.baseUrl}/preview-recipients`,
      dto,
     
    );
  }
}
